<div class="bg-white px-4 py-4 rounded-5">
  <div class="px-2 py-3">
    <div class="text-center mb-3">
      <h2 class="mb-1" style="color: #1A1A1A;">Verify Your Account</h2>
      <p>Enter the 6-digit code from your authenticator app</p>
    </div>


    <div class="alert bg-danger-subtle border-danger-subtle text-danger fs-14 text-center" *ngIf="error">{{error}}</div>

    <div class="mb-3 text-center">
      <app-otp-input
        (onValueChange)="otp = $event;"
        (onVerifyOtp)="proceed()"
      ></app-otp-input>

      <div class="pt-1 fst-italic opacity-70p">
        The code expires every 60 seconds
      </div>
    </div>

    <div class="pt-2">
      <button
        class="btn btn-success w-100"
        (click)="proceed()"
        [disabled]="working"
      >
        Verify Code
        <ng-container *ngIf="!working"><iconify name="majesticons:chevron-right"></iconify></ng-container>
        <ng-container *ngIf="working"><loading-icon></loading-icon></ng-container>
      </button>
    </div>
  </div>
</div>
